import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { Brand } from 'src/app/main/model/ddb.model';
import { BrandService } from 'src/app/main/services/brand.service';

@Component({
  selector: 'app-brand-li',
  templateUrl: './brand-li.component.html',
  styleUrls: ['./brand-li.component.sass']
})
export class BrandLiComponent {
  brands: Brand[] = [];
  filteredBrands: Brand[] = [];

  tabs: string[] = [
    '0-9',
    ...'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('')
  ];

  activeTab: string = 'all';
  searchTerm: string = '';

  constructor(
    private router: Router,
    private brandService: BrandService
  ) {
    this.getBrands();
  }

  getBrands(): void {
    this.brandService.allBrands$.subscribe(response => {
      this.brands = response.rows;
      this.applyFilters();
    });
  }

  applyFilters(): void {
    let result = [...this.brands];

    if (this.activeTab !== 'all') {
      if (this.activeTab === '0-9') {
        result = result.filter(brand =>
          /^[0-9]/.test(brand.name)
        );
      } else {
        result = result.filter(brand =>
          brand.name?.toUpperCase().startsWith(this.activeTab)
        );
      }
    }

    if (this.searchTerm.trim()) {
      const term = this.searchTerm.toLowerCase();
      result = result.filter(brand =>
        brand.name?.toLowerCase().includes(term)
      );
    }

    this.filteredBrands = result;
  }

  filter(tab: string): void {
    this.activeTab = tab;
    this.applyFilters();
  }

  onSearch(event: Event): void {
    const target = event.target as HTMLInputElement
    const value = target.value
    this.searchTerm = value;
    this.applyFilters();
  }

  handleBrandClick(brandId: string): void {
    this.router.navigate(['/products'], {
      queryParams: { brandId }
    });
  }
}
